import { FC } from "react";
import { TextFieldContainer, CustomTextField } from "./text-field.styles";
import { TextFieldProps as RNTextFieldProps } from "@mui/material";

type TextFieldProps = RNTextFieldProps & {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>> | ((val: string) => void);
};

const TextField: FC<TextFieldProps> = ({ value, setValue, ...props }) => {
  return (
    <TextFieldContainer>
      <CustomTextField
        fullWidth
        value={value}
        onChange={(ev) => {
          setValue(ev.target.value);
        }}
        {...props}
      />
    </TextFieldContainer>
  );
};

export default TextField;
